module.exports = __webpack_public_path__ + "img/list_style_icon.f06a4ad.png";